import React from 'react';
import {SetMetaData} from './../../helper/page-title';
import SAdminResources from './resource-manage';
import ResourcesList from './resource-list';
const fileTypeOpt = [
    {id: 'pdf', file_type: 'PDF'},
    {id: 'video', file_type: 'Video'},
    {id: 'ppt', file_type: 'PPT'},
    {id: 'image', file_type: 'Image'}
];

function GloscoResources(props) {
    SetMetaData("Manage GLOSCO Resources", "", "");

    // 1. Add a check to see if userRoleIds is still loading/empty
    if (!props.userRoleIds || props.userRoleIds.length === 0) {
        return <div className="p-5 text-center">Loading permissions...</div>;
        // Or return null;
    }

    const isAdmin = props.userRoleIds.includes(2) || props.userRoleIds.includes(7);

    return isAdmin ? <SAdminResources fileTypeOpt={fileTypeOpt}/> : <ResourcesList fileTypeOpt={fileTypeOpt}/>;
}

export default GloscoResources;